module.exports = __webpack_public_path__ + "img/aqtobe6.de2b4678.jpg";